import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { LubavButton } from '@backrs_ui/grow-ui/src/components/Lubav/LubavButton';
import type { ScoredComparison } from '@backrs_ui/grow-ui/src/redux/userColleges/userColleges.types';

import { Box, SxProps, Theme, Typography } from '@mui/material';

import { rankedByMatch } from '../compare.util';

const STRINGS = appStrings.modules.myColleges.compare.ask;
const LEVELS = appStrings.modules.myColleges.compare.importanceLabels;

type CompareAskLubavProps = Readonly<{ comparison: ScoredComparison; name: string | null }>;

export const CompareAskLubav = ({ comparison, name }: CompareAskLubavProps) => {
  const [first, second] = rankedByMatch(comparison.colleges);
  const comparisonName = STRINGS.comparisonName(name);
  const cost = comparison.settings.importances.net_cost;
  const costAtTop = cost === LEVELS.length - 1;
  const costTried = costAtTop ? cost - 1 : cost + 1;

  return (
    <Box id="compare-ask-lubav" sx={containerSx}>
      <Typography variant="text-sm-semibold">{STRINGS.title}</Typography>
      <Box sx={buttonsSx}>
        {first && (
          <LubavButton
            id="compare-ask-why-top"
            label={STRINGS.whyTop(first.name)}
            prompt={STRINGS.whyTopPrompt(first.name, comparisonName)}
          />
        )}
        <LubavButton
          id="compare-ask-cost-matters"
          label={costAtTop ? STRINGS.costMattersLess : STRINGS.costMattersMore}
          prompt={STRINGS.costMattersPrompt(comparisonName, LEVELS[cost], LEVELS[costTried])}
        />
        {first && second && (
          <LubavButton
            id="compare-ask-head-to-head"
            label={STRINGS.headToHead(first.name, second.name)}
            prompt={STRINGS.headToHeadPrompt(first.name, second.name, comparisonName)}
          />
        )}
      </Box>
    </Box>
  );
};

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-md'],
});

const buttonsSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: backrs.spacing['spacing-sm'],
});
